import { render, staticRenderFns } from "./LogistikView.vue?vue&type=template&id=4ca8f4cc"
import script from "./LogistikView.vue?vue&type=script&lang=js"
export * from "./LogistikView.vue?vue&type=script&lang=js"
import style0 from "./LogistikView.vue?vue&type=style&index=0&id=4ca8f4cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports